import script from "./NavigationLinksLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationLinksLink.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationLinksLink.vue?vue&type=style&index=0&id=5afd7975&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afd7975"]])

export default __exports__